import { toShortDateString, Validations } from '@/utils'

import InputBasico from './InputBasico'

import { DateTime } from 'luxon'

export const InputData = InputBasico.extend({
	name: 'InputData',
	extends: InputBasico,
	props: {
		label: { default: 'Data', type: String },
		placeholder: { default: 'dd/mm/aaaa' },
		mask: { default: '00/00/0000' }
	},
	beforeMount() {
		if (!this.disabled) this.setRules([...this.rules, Validations.ValidDate], this.$props)

		// Check if Date string is in ISO Format
		// If it is, convert to dd/mm/aaaa
		if (this.value) {
			const dateParsed = DateTime.fromISO(this.value)
			if (dateParsed.isValid) this.handleInput(toShortDateString(this.value))
		}
	},
	watch: {
		disabled() {
			if (this.disabled) this.setRules([], this.$props)
			else this.setRules([...this.rules, Validations.ValidDate], this.$props)
		}
	}
})

export default InputData
